import { CategoryGroupName } from 'typings/filters'

export const generalCategoryGroupNames = [
  CategoryGroupName.General_Base,
  CategoryGroupName.General_Shopper,
  CategoryGroupName.General_Purchase,
  CategoryGroupName.General_Product,
  CategoryGroupName.General_Archive,
]

export const productReviewCategoryGroupNames = [
  CategoryGroupName.ProductReview_Base,
  CategoryGroupName.ProductReview_Purchase,
  CategoryGroupName.ProductReview_Review,
]

export const allCategoryGroupNames: CategoryGroupName[] = [
  ...generalCategoryGroupNames,
  ...productReviewCategoryGroupNames,
]

export const categoryGroupShortNames: Record<CategoryGroupName, string> = {
  [CategoryGroupName.General_Base]: 'Base',
  [CategoryGroupName.General_Shopper]: 'Shopper',
  [CategoryGroupName.General_Purchase]: 'Purchase',
  [CategoryGroupName.General_Product]: 'Product',
  [CategoryGroupName.General_Archive]: 'Archive',

  [CategoryGroupName.ProductReview_Base]: 'Base',
  [CategoryGroupName.ProductReview_Purchase]: 'Purchase',
  [CategoryGroupName.ProductReview_Review]: 'Review',
}

export const generalCategoryGroupLabelToName: Record<string, CategoryGroupName> = {
  Base: CategoryGroupName.General_Base,
  Shopper: CategoryGroupName.General_Shopper,
  Purchase: CategoryGroupName.General_Purchase,
  'Product Specification': CategoryGroupName.General_Product,
  Archive: CategoryGroupName.General_Archive,
}

export const productReviewCategoryGroupLabelToName: Record<string, CategoryGroupName> = {
  Base: CategoryGroupName.ProductReview_Base,
  Purchase: CategoryGroupName.ProductReview_Purchase,
  Review: CategoryGroupName.ProductReview_Review,
}
